import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate();
    return <div>
        
        <main aria-labelledby="pageTitle" className="flex items-center justify-center h-screen bg-blue-950">
            <div className="p-4 space-y-4">
                <div className="flex flex-col items-start space-y-3 sm:flex-row sm:space-y-0 sm:items-center sm:space-x-3">
                    <p className="font-semibold  text-9xl text-red-600 ">400</p>
                    <div className="space-y-2">
                        <h1 id="pageTitle" className="flex items-center space-x-2">
                            <svg aria-hidden="true" className="w-6 h-6 text-red-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                            <span className="text-xl font-medium text-white sm:text-2xl ">
                                Oops! Something went wrong.
                            </span>
                        </h1>
                        <p className="text-base font-normal text-gray-100 ">
                            The page you are looking for is temporarily unavailable.
                        </p>
                        <p className="text-base font-normal text-gray-100 ">
                            You may return to&nbsp;
                            <a href="/" className="text-blue-600 hover:underline dark:text-blue-500">
                                Home Page
                            </a>
                            {/* or&nbsp;
                            <a onClick={() => navigate('/')} className="text-blue-600 cursor-pointer hover:underline dark:text-blue-500">
                                Previous Page
                            </a>&nbsp; */}
                            {/* <br></br>or try using the search bar. */}
                        </p>
                    </div>
                </div>

                {/* <form action="#">
            <div className="flex items-center justify-center border-gray-400 border rounded-lg">
              <input type="text" name="search" placeholder="What are you looking for?" className="w-full px-4 py-2 rounded-l-lg " />
              <button className="p-2 text-black rounded-r-md">
                <span className="sr-only">Search</span>
                < />
              </button>
            </div>
          </form> */}
            </div>
        </main>
    </div>;
};

export default PageNotFound;
